import { render } from "./HealthCertificates.vue?vue&type=template&id=3efdf975&scoped=true"
import script from "./HealthCertificates.vue?vue&type=script&lang=js"
export * from "./HealthCertificates.vue?vue&type=script&lang=js"

import "./HealthCertificates.vue?vue&type=style&index=0&id=3efdf975&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3efdf975"]])

export default __exports__